$(document).ready(function () {

	$('#slick-static-feat').slick({
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 6000,
		pauseOnHover: true,
		cssEase: 'linear',	
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
			breakpoint: 991,
			settings: {
			  slidesToShow: 3,
			  slidesToScroll: 1,
			}
		  },
		  {
			breakpoint: 767,
			settings: {
			  slidesToShow: 2,
			  slidesToScroll: 1,
			}
		  },
		  {
			breakpoint: 480,
			settings: {
			  slidesToShow: 1.4,
			  slidesToScroll: 1,
			}
		  }
		]
	  });


	  $('.slick-help-lr').slick({
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		swipeToSlide: true,
		speed: 8000,
		pauseOnHover: true,
		cssEase: 'linear',	
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
			breakpoint: 991,
			settings: {
			  slidesToShow: 3,
			  slidesToScroll: 1,
			}
		  },
		  {
			breakpoint: 767,
			settings: {
			  slidesToShow: 2,
			  slidesToScroll: 1,
			}
		  },
		  {
			breakpoint: 480,
			settings: {
			  slidesToShow: 2,
			  slidesToScroll: 1,
			}
		  }
		]
	  });

	  $('.slick-help-rl').slick({
		dots: false,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 8000,
		pauseOnHover: true,
		swipeToSlide: true,
		cssEase: 'linear',	
		slidesToShow: 5,
		rtl: true,
		slidesToScroll: 1,
		initialSlide: 1,
		responsive: [
			{
			breakpoint: 991,
			settings: {
			  slidesToShow: 3,
			  slidesToScroll: 1,
			}
		  },
		  {
			breakpoint: 767,
			settings: {
			  slidesToShow: 2,
			  slidesToScroll: 1,
			}
		  },
		  {
			breakpoint: 480,
			settings: {
			  slidesToShow: 2,
			  slidesToScroll: 1,
			}
		  }
		]
	  });


	  $('#slick-review').slick({
		dots: false,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 600,
		pauseOnHover: true,
		cssEase: 'linear',	
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
			breakpoint: 991,
			settings: {
			  slidesToShow: 1,
			  slidesToScroll: 1,
			}
		  }
		]
	  });


  $('#slick-compare').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 600,
    cssEase: 'linear',	
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $('.card-toggle').on('click', function() {
    // Remove 'card-reverted' class from all .work-card elements
    $('.work-card').removeClass('card-reverted');
            
    // Add 'card-reverted' class to the clicked .work-card
    $(this).closest('.work-card').addClass('card-reverted');
  });

  /*_____ FAQ's _____*/
  $(document).on("click", ".faq__blk > h5", function () {
    $(".faq__blk").not($(this).parent().toggleClass("active")).removeClass("active")
    $(".faq__blk>.text").not($(this).parent().find(".text").slideToggle()).slideUp()
  })

  $('#slick-work').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 600,
    cssEase: 'linear',	
    slidesToShow: 3,
    slidesToScroll: 1,
    // centerMode: true,
    responsive: [
        {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        }
      }
    ]
  });

});

